function getHmToken () {
  return localStorage.getItem('hmToken')
}

function setHmToken (token = null) {
  if (token) {
    localStorage.setItem('hmToken', token)
  } else {
    localStorage.removeItem('hmToken')
  }
}

function cleanHmToken () {
  localStorage.removeItem('hmToken')
}

export { getHmToken, setHmToken, cleanHmToken }
